import { useEffect, useState } from "react";
import axios from "axios";
// Note: You'll need to install lucide-react: npm install lucide-react
import { Briefcase, Building, MapPin, Link2, Mail, MessageCircle} from "lucide-react";
import { useAuth } from '../services/AuthContext.js'; // Import your AuthContext
import "./jobs.css";
import { Link, useNavigate } from "react-router-dom";

// Set the axios base URL
axios.defaults.baseURL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

function Job ({ jobId }) {
    const [job, setJob] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchJob();
    }, []);

    const fetchJob = async () => {
        try {
        setLoading(true);
        setError(null);
        const response = await axios.get(`/get-job/${jobId}`);
        console.log("Fetched jobs:", response.data);
        setJob(response.data);
        } catch (err) {
        console.error("Error fetching jobs:", err);
        setError("Não foi possível carregar os jobs");
        } finally {
        setLoading(false);
        }
    };

    return (
        <div className="jobs-container">
            <div>
                <div className="flex-row">
                    <h2>{job.title}</h2>
                </div>
            </div>
            <div>
                <div className="flex-row">
                    <Building size={24} />
                    <h3>{job.company}</h3>
                    <MapPin size={24} />
                    <h3>{job.location}</h3>
                </div>
                {job.description?.split('\n').map((line, index) => (
                <p key={index}>{line}</p>
                ))}
                <div className="flex-row">
                    <Link2 size={18} />
                    <a href={job.link}>{job.link}</a>
                </div>
                <div className="flex-row">
                    <Mail size={18} />
                    {job.email}
                </div>
            </div>
        </div>
    );
}

export {Job};